<template>
  <div class="overlay overlay--grow" v-show="modalVisible">
    <transition name="slideDown">

      <div>
        <div ref="target" class="overlay__inner" v-show="modalVisible" @click.stop>
          <div class="email-push-config app-modal">
            <div class="app-modal__buttons">
              <button class="btn btn-icon app-modal__close" aria-label="close"
                @click.prevent="cancel"
              ><i class="fa fa-close"></i></button>
            </div>
            <h3 
              class="app-modal__head app-modal__head--main" 
              @mouseenter="moveable.draggable = true"
              @mouseleave="moveable.draggable = false"
            >Set Dashboard Email Push</h3>
            <div class="app-modal__inner">
              <p>Select Dashboard Email Push frequency <strong class="salmon"><i>for all utilities:</i></strong></p>

              <label>
                <input type="radio" v-model="emailPushFrequency" value="weekly"> 
                Weekly
              </label>

              <label>
                <input type="radio" v-model="emailPushFrequency" value="monthly"> 
                Monthly
              </label>

              <label>
                <input type="radio" v-model="emailPushFrequency" value="never"> 
                Don't Send
              </label>

              <button class="btn mrgn-right-10" 
                @click.prevent="save"
              >Save</button>

              <a href="#" @click.prevent="cancel">Cancel</a>
            </div>
          </div>
        </div>

        <Moveable
          className="moveable"
          :target="$refs.target"
          :draggable="moveable.draggable"
          :origin="false"
          @drag="handleDrag"
        />
      </div>

    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import Moveable from 'vue3-moveable'

export default {
  props: ['modalVisible'],
  components: {
    Moveable
  },
  data () {
    return {
      updatedFrequency: null,
      moveable: {
        draggable: false,
      }
    }
  },
  computed: {
    emailPushFrequency: {
      get: function() {
        if (this.updatedFrequency) {
          return this.updatedFrequency
        } else if (this.userPreferences && this.userPreferences.emailPushFrequency) {
          return this.userPreferences.emailPushFrequency
        }
      },
      set: function(newFrequency) {
        this.updatedFrequency = newFrequency
      }
    },
    userPreferences() {
      return this.$store.getters.userPreferences
    }
  },
  methods: {
    handleDrag({ target, transform }) {
      let ogTransform = target.style.transform

      target.style.transform = transform

      let bounding = target.getBoundingClientRect();

      if (bounding.top < 0) {
        target.style.transform = ogTransform
      }
    },
    toggleModal() {
      this.$emit('toggleEmailPushModal')
    },
    cancel() {
      this.updatedFrequency = null
      this.toggleModal()
    },
    save() {
      if (! this.updatedFrequency) {
        this.toggleModal()
        return
      }
      
      axios.post('/pricing-calculator/me/preferences', { emailPushFrequency: this.emailPushFrequency })
        .then(response => {
          this.toggleModal()
          this.$store.dispatch('setUserPreferences', response.data.preferences)
        })
    }
  }
}
</script>
